export enum VARIABLE_TYPE {
  firstName = '{{First Name}}',
  lastName = '{{Last Name}}',
  companyName = '{{Company Name}}'
}
